// src/routes.ts

export const ROUTES = {
  HOME: "/",
  AUTH: "/auth",
  FORGOT_PASSWORD: "/forgot-password",
  ENTERPRISE: "/enterprise",
  ENTERPRISE_SEARCH: "/enterprise/search",
  ENTERPRISE_TALENT: "/enterprise/talent",
  ENTERPRISE_TRAINING: "/enterprise/training",
  DOCUMENTATION: "/documentation",
  TUTORIALS: "/tutorials",
  ABOUT_US: "/about",
  CAREERS: "/careers",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_SERVICE: "/terms-of-service",
  TERMS_OF_SERVICE_FREELANCER: "/terms-of-service-freelancer-contract",
  TERMS_OF_SERVICE_ENTERPRISE: "/terms-of-service-enterprise-contract",
  TERMS_AND_CONDITION_CONTRACT: "/terms-and-condition-contract",
  COOKIE_POLICY: "/cookie-policy",
  SECURITY: "/security",
  GDPR_COMPLIANCE: "/gdpr-compliance",
  SUPPORT_CENTER: "/support-center",

  // Protected Routes
  DASHBOARD: "/dashboard",
  PROFILE: "/profile",
  ENTERPRISE_TO_FREELANCER: (jobId: string | number, freelancerId?: string | number) =>`/job-details/${jobId}${freelancerId ? `?freelancerId=${freelancerId}` : ''}`,
  PROJECTS: "/projects",
  MYJOBS: "/job-list",
  PROJECT_DETAILS: (id: string | number) => `/project-details/${id}`,
  JOB_DETAILS: (id: string | number) => `/job-details/${id}`,
  PROJECT_COLLABORATIONS: "/project-collaborations",
  WALLET: "/wallet",
  PAYMENT_HISTORY: "/paymentHistory",
  MARKETPLACE: "/marketplace",
  PROPOSALS: "/proposals",
  REVIEWS: "/reviews",
  CONTRACTS: "/contracts",
  POSTS: "/posts",
  MESSAGES: "/messages",
  INTERVIEWS: "/interviews",
  TIME_TRACKING: "/time-tracking",
  INCOME: "/income",
  ANALYTICS: "/analytics",
  ROI_CALCULATOR: "/roi-calculator",
  JOB_SWIPE: "/job-swipe",
  LIKED_JOBS: "/liked-jobs",
  AI_JOB_MATCHING: "/ai-job-matching",
  AI_AGENTS: "/ai-agents",
  SKILLS_TEST: "/skills-test",
  CLIENT: "/client",
  PERFORMANCE: "/performance",
  SUBMIT_PROJECT: "/create-job",
  FREELANCERS: "/freelancers",
  AGENCY: "/agency",
  TEAM_BUILDER: "/team-builder",
  FREELANCER_TRAINING: "/freelancer-training",
  DIGITAL_PORTFOLIO: "/digital-portfolio",
};

export const API_END_POINTS = {
  LOGIN: "/api/auth/login",
  SIGNUP: "/api/auth/register",
  FORGOT_PASSWORD: "/api/auth/forgot-password",
  RESET_PASSWORD: "/api/auth/reset-password",
  RESEND_VERIFICATION_EMAIL: "/api/auth/resend-code",
  CONFIRM_CODE: "/api/auth/confirm-code",
  GOOGLE_AUTH: "/api/auth/google-auth",
  REFRESH_TOKEN: "/api/auth/refresh-token",
  VERIFY_OTP: "/api/auth/verify-code",
  LOGOUT: "/api/auth/logout",
  CREATE_FREELANCER_PROFILE: "/api/freelancer",
  GET_ALL_FREELANCER: "/api/freelancer",
  GET_FREELANCER_PROFILE: `/api/freelancer/profile`,
  UPDATE_FREELANCER_PROFILE: `/api/freelancer`,
  UPLOAD_FREELANCER_RESUME: `/api/freelancer/upload/resume`,
  GET_FREELANCER_APPLICATIONS: `api/freelancer/applications`,
  CREATE_ENTERPRISE_PROFILE: "/api/enterprise",
  GET_ALL_ENTERPRISE: "/api/enterprise",
  GET_ENTERPRISE_PROFILE: `/api/enterprise/profile`,
  UPDATE_ENTERPRISE_PROFILE: `/api/enterprise`,
  UPLOAD_ENTERPRISE_PROFILE_PICTURE: `api/enterprise/upload/profile-picture`,
  UPLOAD_FREELANCER_PROFILE_PICTURE: `api/freelancer/upload/profile-picture`,
  CREATE_JOB: "/api/jobs",
  GET_ALL_JOBS: "/api/jobs",
  GET_JOB_DETAILS: `/api/jobs/user`,
  UPDATE_JOB: `/api/jobs`,
  UPLOAD_JOB_ATTACHMENT: `/api/jobs/upload/job`,
  ARCHIVED_JOB: `/api/jobs`,
  APPLY_JOB: `/api/jobApply`,
  GET_JOB_APPLICATIONS: `/api/jobApply/applications`,
  GET_AI_RECOMMENDED_FREELANCER_JOB: `/api/jobs/match`,
  UPDATE_JOB_APPLICATION_STATUS: `/api/jobApply`,
  UPLOAD_JOB_APPLICATION_COVER_LETTER: `/api/jobApply/upload/coverletter`,
  GET_ALL_PROJECTS:`api/freelancer/match`,
  GET_JOB_DETAILS_BY_FREELANCER:`/api/jobs`,
  INITIATE_CHAT: "/api/conversation/initiate",
  LIST_CONVERSATIONS: "/api/chat/conversation",
  GET_MESSAGE: "/api/chat/messages",
  CREATE_CONTRACT: "api/contract",
  GET_CONTRACT_BASED_ON_FREELANCER: "api/contract/freelancer/",
  GET_CONTRACT_BASED_ON_ENTERPRISE: "api/contract/enterprise/",
  ACCEPT_CONTRACT: "api/contract/",
  ADD_UPDATE_MILESTONE: "api/milestone",
  WITHDRAW_APPLICATION: `/api/jobApply/application`,
  GET_ALL_NOTIFICATION_LIST: "/api/notifications/",
  NEWS_LATTER_SUBSCRIBE: "/api/newsletter/subscribe",
  CREATE_ORDER: "api/transaction/create-order",
  CHECK_STATUS: "/api/transaction/check-status",
  TRANSACTION_HISTORY: "/api/transaction/history",
  CANCEL_PAYMENT: "/api/transaction",
  PROCESS_PAYMENT: "/api/transaction/process-payment",
  RELEASE_PAYMENT: "/api/transaction/release",
  BINANCE_ID : '/api/transaction/binance-id'
};
